import * as React from 'react'
import { NestedBlock } from '../../blocks.state'
import { OfficeBlockLayout } from '../officeBlock/officeBlock.layout'
import { NestedDownloadBlockLayout } from './nestedDownloadBlock/nestedDownloadBlock.layout'
import { NestedQuoteBlockLayout } from './nestedQuoteBlock/nestedQuoteBlock.layout'
import { NestedTextBlockLayout } from './nestedTextBlock/nestedTextBlock.layout'

export const NestedBlocks = ({ nestedBlocks }: { nestedBlocks: NestedBlock[] }) => (
  <>
    {nestedBlocks.map((block, i) => {
      switch (block.kind) {
        case 'nestedTextBlock':
          return <NestedTextBlockLayout key={i} {...block} />
        case 'nestedQuoteBlock':
          return <NestedQuoteBlockLayout key={i} {...block} />
        case 'nestedOfficeBlock':
          return <OfficeBlockLayout key={i} {...block} id={`office-${i}`} nested />
        case 'nestedDownloadBlock':
          return <NestedDownloadBlockLayout key={i} {...block} />
      }
    })}
  </>
)
